import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ y, opacity: 0 }}
    whileInView={{ y: 0, opacity: 1 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, ease: "easeOut", delay }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <p
    className={`flex items-center gap-3 font-mono text-xs tracking-[0.25em] uppercase text-zinc-500 ${className}`}
  >
    <span className="h-1.5 w-1.5 bg-crimson inline-block" aria-hidden="true" />
    {children}
  </p>
);
